import { render, staticRenderFns } from "./checkupLayout.vue?vue&type=template&id=35d52d56&scoped=true&"
import script from "./checkupLayout.vue?vue&type=script&lang=js&"
export * from "./checkupLayout.vue?vue&type=script&lang=js&"
import style0 from "./checkupLayout.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./checkupLayout.vue?vue&type=style&index=1&id=35d52d56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d52d56",
  null
  
)

export default component.exports